import { useEffect, useMemo, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';

import { savePagePhotos } from '../../globalState/object/actions';

import PhotoAdd from './containers/PhotoAdd';
import PhotoStickyBottomButtons from './components/PhotoStickyBottomButtons';

import PhotoAlertBox from './components/PhotoAlertBox';
import PhotoErrorBoxList from './components/PhotoErrorBoxList';
import PhotosContainer from './components/PhotosContainer';
import PhotoModalSave from './components/PhotoModalSave';
import PhotoModalDelete from './components/PhotoModalDelete';
import PhotoModalResolve from './components/PhotoModalResolve';
import PhotoModalSetDisaproovedReason from './components/PhotoModalSetDisaproovedReason';

import * as localStore from './localStore/localReducer';

const initialLocalState = {
  tempAproovedPhoto: [],
  tempDisaproovedPhoto: [],
  errorList: [],
  showModal: null,
  unsavedPage: false,
};

const ObjectPhotoComponent = ({
  baseUrl,
  isMobile,
  userRole,
  objectId,
  aproovedPhotos,
  disaproovedPhotos,
  isFastPhoto,
}) => {
  const dispatch = useDispatch();
  const [localState, localDispatch] = useReducer(
    localStore.localReducer,
    initialLocalState
  );

  const [orderedPhoto, setOrderedPhoto] = useState([]);
  useEffect(() => {
    setOrderedPhoto(aproovedPhotos);
  }, [aproovedPhotos]);

  const sendPhotoData = async (objectId, photos, photoActionType = 'save') => {
    const formData = new FormData();
    formData.append(`object`, objectId);
    formData.append(`section`, 'photo');
    formData.append(
      `data`,
      JSON.stringify({
        photos: { ...photos },
        operationType: photoActionType,
      })
    );
    localDispatch({ type: localStore.RESET_ERROR_LIST });
    return await dispatch(savePagePhotos(formData, 'photo'));
  };

  const setErrorList = (error) => {
    localDispatch({
      type: !!error ? localStore.SET_ERROR_LIST : localStore.RESET_ERROR_LIST,
      payload: error,
    });
  };

  const showModalHandler = (typeOfModal, payload) => {
    let action;
    switch (typeOfModal) {
      case 'reject':
        action = localStore.TOGGLE_DISAPROOVED_SET_MODAL;
        break;
      case 'delete':
        action = localStore.TOGGLE_DELETE_MODAL;
        break;
      case 'resolve':
        action = localStore.TOGGLE_APROOVED_SET_MODAL;
        break;
      case 'save':
      default:
        action = localStore.TOGGLE_SAVE_MODAL;
        break;
    }
    return localDispatch({ type: action, payload: payload ?? action });
  };

  const savePageHandler = (() => (type, list) => {
    sendPhotoData(objectId, list, type);
    localDispatch({ type: localStore.CLEAR_TEMP_LISTS });
    localDispatch({
      type: localStore.TOGGLE_SHOW_BOTTOM_BUTTONS,
      payload: false,
    });
  })();

  const setReasonToDisaproovedPhoto = (index, reason) => {
    localDispatch({
      type: localStore.SET_REASON_TO_DISAPROOVED_PHOTO,
      payload: { index, reason },
    });
  };

  const photoCheckboxHandler = (event, item, list, isAproovedPhotoList) => {
    if (event.currentTarget.checked) {
      localDispatch({
        type: isAproovedPhotoList
          ? localStore.ADD_TO_APROOVED_TEMP_LIST
          : localStore.ADD_TO_DISAPROOVED_TEMP_LIST,
        payload: item,
      });
      if (list?.length) {
        localDispatch({
          type: isAproovedPhotoList
            ? localStore.CLEAR_DISAPROOVED_TEMP_LIST
            : localStore.CLEAR_APROOVED_TEMP_LIST,
        });
      }
    } else {
      localDispatch({
        type: isAproovedPhotoList
          ? localStore.REMOVE_FROM_APROOVED_TEMP_LIST
          : localStore.REMOVE_FROM_DISAPROOVED_TEMP_LIST,
        payload: item,
      });
    }
  };


  useEffect(() => {
    if (!localState.unsavedPage)
      localDispatch({
        type: localStore.TOGGLE_SHOW_BOTTOM_BUTTONS,
        payload:
          localState.tempAproovedPhoto.length ||
          localState.tempDisaproovedPhoto.length,
      });
  }, [localState.tempAproovedPhoto, localState.tempDisaproovedPhoto, localState.unsavedPage]);

  const totalPhotoCount = useMemo(() => aproovedPhotos?.length + disaproovedPhotos?.length, [aproovedPhotos, disaproovedPhotos])

  return (
    <>
      <PhotoAlertBox className={'alert-warning'}>
        {'Размер фотографий должен быть не менее 400x400 пикселей'}
      </PhotoAlertBox>
      {!!localState.errorList?.length && (
        <PhotoErrorBoxList data={localState.errorList}/>
      )}
      <PhotoAdd
        objectId={objectId}
        section={'photo'}
        maxCount={50}
        currentCount={aproovedPhotos?.length + disaproovedPhotos?.length}
        setErrorList={setErrorList}
      />

      <PhotoAlertBox className='alert-dark'>
        Одобрено {aproovedPhotos?.length}
        {` `}
        {Number.isInteger(totalPhotoCount) && `из ${totalPhotoCount}`} фото.
        Минимальное количество фото - 5.
        Максимальное количество фото - 50.
      </PhotoAlertBox>
      <PhotosContainer
        baseUrl={baseUrl}
        mobileAgent={isMobile}
        orderedPhoto={orderedPhoto}
        disaproovedPhotos={disaproovedPhotos}
        tempAproovedPhoto={localState.tempAproovedPhoto}
        tempDisaproovedPhoto={localState.tempDisaproovedPhoto}
        setOrderedPhoto={setOrderedPhoto}
        photoCheckboxHandler={photoCheckboxHandler}
        setShowBottomButtons={() => {
          localDispatch({
            type: localStore.TOGGLE_SHOW_BOTTOM_BUTTONS,
            payload: true,
          });
        }}
      />
      {!!localState.unsavedPage && (
        <PhotoStickyBottomButtons
          userRole={userRole}
          orderedPhoto={orderedPhoto}
          tempAproovedPhoto={localState.tempAproovedPhoto}
          tempDisaproovedPhoto={localState.tempDisaproovedPhoto}
          clickButtonHandler={showModalHandler}
        />
      )}
      <PhotoModalDelete
        toggleShow={() => showModalHandler('delete', 'none')}
        action={() =>
          savePageHandler(
            'delete',
            localState.tempAproovedPhoto.length
              ? localState.tempAproovedPhoto
              : localState.tempDisaproovedPhoto
          )
        }
        show={localState.showModal === localStore.TOGGLE_DELETE_MODAL}
        count={
          localState.tempAproovedPhoto.length ||
          localState.tempDisaproovedPhoto.length
        }
      />
      <PhotoModalSave
        toggleShow={() => showModalHandler('save', 'none')}
        action={() => savePageHandler('save', orderedPhoto)}
        show={localState.showModal === localStore.TOGGLE_SAVE_MODAL}
      />
      <PhotoModalResolve
        toggleShow={() => showModalHandler('resolve', 'none')}
        action={() =>
          savePageHandler('resolve', localState.tempDisaproovedPhoto)
        }
        show={localState.showModal === localStore.TOGGLE_APROOVED_SET_MODAL}
        count={localState.tempDisaproovedPhoto.length}
      />
      <PhotoModalSetDisaproovedReason
        show={localState.showModal === localStore.TOGGLE_DISAPROOVED_SET_MODAL}
        toggleShow={() => {
          showModalHandler('reject', 'none');
        }}
        onSubmit={() => {
          savePageHandler('reject', localState.tempAproovedPhoto);
        }}
        tempAproovedPhoto={localState.tempAproovedPhoto}
        baseUrl={baseUrl}
        setReason={setReasonToDisaproovedPhoto}
      />
    </>
  );
};

export default ObjectPhotoComponent;
